import {Component, OnInit} from '@angular/core';
import {AppComponent} from './app.component';
import {TenantService} from "../../../../features/auth/tenant/tenant.service";

@Component({
    selector: 'app-footer',
    template: `
        <div class="layout-footer flex align-items-center p-4 shadow-2">
            <img id="footer-logo" [src]="footerLogo" alt="footer-logo" style="height: 3rem">
            <button pButton pRipple type="button" icon="pi pi-github fs-large" class="p-button-rounded p-button-text p-button-plain" [ngClass]="{'ml-auto mr-2': !app.isRTL, 'ml-2 mr-auto': app.isRTL}"></button>
            <button pButton pRipple type="button" icon="pi pi-facebook fs-large" class="p-button-rounded p-button-text p-button-plain" [ngClass]="{'mr-2': !app.isRTL, 'ml-2': app.isRTL}"></button>
            <button pButton pRipple type="button" icon="pi pi-twitter fs-large" class="p-button-rounded p-button-text p-button-plain" [ngClass]="{'mr-2': !app.isRTL, 'ml-2': app.isRTL}"></button>
        </div>
    `,
    standalone: false
})
export class AppFooterComponent implements OnInit {
    footerLogo: string;

    constructor(public app: AppComponent, private tenantService: TenantService) {}

    ngOnInit() {
        const tenantInfo = this.tenantService.getTenantInfo();
        if (this.app.layoutMode === 'light') {
            this.footerLogo = tenantInfo.logoDark || tenantInfo.logoColorDark || tenantInfo.logo;
        } else {
            this.footerLogo = tenantInfo.logoBright || tenantInfo.logoColorBright || tenantInfo.logo;
        }
    }
}
